<template>
  <div class="paint-app pixelated" v-bind:class="{color: state.colorDisplay }">
    <div class="background overlay stretchy greentone" style="z-index: -2"></div>
    <div class="background2 overlay stretchy halftone" style="z-index: -1"></div>
    <win-header v-bind:title="'Paint - '+ state.title"></win-header>
    <file-menu></file-menu>
    <tool-bar></tool-bar>
    <drawing-panel></drawing-panel>
    <bottom-bar show-disk="1"></bottom-bar>
    <palettes></palettes>
  </div>
</template>

<script>

  import BottomBar from './BottomBar.vue'
  import DrawingPanel from './DrawingPanel.vue'
  import ToolBar from './ToolBar.vue'
  import WinHeader from './WinHeader.vue'
  import FileMenu from './FileMenu.vue'
  import Palettes from './Palettes.vue'

  import _ from 'lodash'

  import config from '../data/config';
  import state from '../data/state';

  export default{
    data(){
      return {
        config: config,
        state: state,
      }
    },
    components: {
      BottomBar,
      WinHeader,
      FileMenu,
      DrawingPanel,
      ToolBar,
      Palettes
    },
    methods: {
      // App level commands
      runCommand(e) {
        const $btn = $(e.target);
        const cmd = $btn.data('cmd');
        const arg = $btn.data('arg');

        if (cmd && _.isFunction(this[cmd])) {
          console.log('Running App Command', cmd, arg);
          this[cmd].call(this, arg);
        } else {
          if (state && _.isFunction(state[cmd])) {
            console.log('Running State Command', cmd, arg);
            state[cmd].call(state, arg);
          } else {
            console.log('Command not found', cmd);
          }
        }
      },

      new() {
        window.paint.clear();
        state.title = '(untitled)';
      },

      save() {
        // TODO: show save dialog
        if(window.paint.download()) {
          state.title = 'MYPICTU~.PNG';
        }
      },

      // EDIT

      erase() {
        window.paint.clear();
        state.title = '(untitled)';
      },

      undo() {
        window.paint.undo();
      },

      redo() {
        window.paint.redo();
      },

      share(site) {

        var url;

        switch (site) {
          case 'twitter':
            url = `http://twitter.com/intent/tweet?status=${config.shareTitle + ' ' + config.shareUrl}`;
            break;
          case 'facebook':
            url = `http://www.facebook.com/sharer/sharer.php?u=${config.shareUrl}&title=${config.shareTitle}`;
            break;

        }

        if (url) {
          document.location.href = url;
        }
      },

      backToDos() {
        state.currentView = 'dos-executive';
      }

    },
    ready() {
      state.setTool('pencil');
      $(this.$el).on('click', '*[data-cmd]', this.runCommand);

      // Transition In
      var $background = $('.background', this.$el);
      var $background2 = $('.background2', this.$el);

      var $children = [
        $('.top-bar', this.$el),
        $('.menu-bar', this.$el),
        $('.toolbar', this.$el),
        $('.bottom-bar', this.$el),
        $('.drawing-panel', this.$el),
        $('.info-panel', this.$el),
        $('.tools', this.$el),
        $('.drawing-canvas', this.$el)
      ];

      //console.log('Intro Paint');

      _.each($children, ($child, i )=> {
        let delay = .75 + i * (.2 + Math.random() * .1);
        TweenLite.set($child, { opacity: 0});
        TweenLite.to($child, .12, { delay: delay, opacity: 1.0});
      });

      TweenLite.set($background, {opacity: 1.0});
      TweenLite.to($background, .5, {opacity: 0, delay: 4});

      TweenLite.set($background2, {opacity: 0});
      TweenLite.to($background2, .15, {opacity: 1, delay: 1.25});
      TweenLite.to($background2, .5, {opacity: 0, delay: 4});

      this.tweenedThings = $children.concat([$background, $background2]);

    },
    onBeforeDestroy() {
      $(this.$el).off('click', '*[data-cmd]', this.runCommand);

      if(this.tweenedThings) {
        TweenLite.killTweensOf(this.tweenedThings)
      }
    }

  }

</script>



// WEBPACK FOOTER //
// PaintApp.vue?8be4c2fe